import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { HollowDotsSpinner } from "react-epic-spinners";
import { enforceSingleTab } from "../utils/sessionGuard";

export default function ProtectedRoute() {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let mounted = true;
    enforceSingleTab().then((allowed) => {
      if (!mounted) return;
      const authed =
        !!sessionStorage.getItem("token") &&
        !!sessionStorage.getItem("user") &&
        !!sessionStorage.getItem("tenantId");
      setStatus(allowed && authed ? "ok" : "denied");
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (status === "checking") {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <HollowDotsSpinner color="#4A90E2" size={40} />
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
